import React from 'react';

const CurriculumSupportIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
			<g clipPath="url(#clip0_9926_6300)">
				<path d="M5.24997 2.33337V3.13837C4.7658 2.94587 4.24663 2.84671 3.72747 2.84671C2.6833 2.84671 1.63913 3.24337 0.839966 4.04254L2.78247 5.98504H3.42997V6.63254C3.93163 7.13421 4.58497 7.39671 5.24413 7.42587V8.75004H3.49997V10.5C3.49997 11.1417 4.02497 11.6667 4.66663 11.6667H10.5C11.4683 11.6667 12.25 10.885 12.25 9.91671V2.33337H5.24997ZM11.0833 9.91671C11.0833 10.2375 10.8208 10.5 10.5 10.5C10.1791 10.5 9.91663 10.2375 9.91663 9.91671V8.75004H6.41663V7.23921C6.74913 7.10504 7.0583 6.90671 7.32663 6.63837L7.4433 6.52171L9.09413 8.16671H9.91663V7.34421L6.41663 3.86171V3.50004H11.0833V9.91671Z" fill="#757575" />
			</g>
			<defs>
				<clipPath id="clip0_9926_6300">
					<rect width="14" height="14" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default CurriculumSupportIcon;
